import { NSBarActionProps, NSBarTitleProps } from "namirasoft-site-react";
import { IEntityInfo, NSARouterMakerProps, NSALayout, NSASectionEditProps, NSASectionListProps, NSASectionViewProps } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";

interface CredentialLayoutProps<EntityType extends { id: string }, EntityTypeInput = EntityType> extends NSARouterMakerProps 
{
	action?: NSBarActionProps;
	title?: NSBarTitleProps;
	pages?: {
		entity: IEntityInfo<EntityType, EntityTypeInput>;
		ui?: {
			action?: {
				menus: {
					view?: boolean;
					viewHistory?: boolean;
					copy?: boolean;
					edit?: boolean;
					delete?: boolean;
					apply?: boolean;
				};
			};
		};
		list?: NSASectionListProps<EntityType>;
		edit?: NSASectionEditProps<EntityType, EntityTypeInput>;
		view?: NSASectionViewProps<EntityType>
	}
	edit?: () => void;
	delete?: () => void;
	redirectToView?: () => void;
	children: JSX.Element | JSX.Element[];
}

export function CredentialLayout<EntityType extends { id: string } = any, EntityTypeInput = EntityType>(props: CredentialLayoutProps<EntityType, EntityTypeInput>)
{
	return (
		<NSALayout
			product_id={ProductUUID.NAMIRASOFT_CREDENTIAL}
			notifications={props.notifier.getNotifications()}
			action={props.action}
			title={props.title}
			pages={props.pages}
			account={props.account}
			url={props.url}
			notifier={props.notifier}
		>
			{props.children}
		</NSALayout>
	);
};